export * from './star-icon.tsx'
